import { render, staticRenderFns } from "./authorityApplyTask.vue?vue&type=template&id=19ecf5ee&scoped=true"
import script from "./authorityApplyTask.vue?vue&type=script&lang=js"
export * from "./authorityApplyTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ecf5ee",
  null
  
)

export default component.exports